import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import
InvestorDeckStepsComponent,
{
  InvestorDeckComponentProps
}
  from 'src/modules/investor-deck/partials/InvestorDeckSteps.component';
import Base64Encoder from 'src/services/encoders/Base64Encoder';
import {
  createInvestorDeck,
  CreateInvestorDeckAction,
  CreateInvestorDeckSuccess
} from 'src/actions/investor-deck/create/CreateInvestorDeck.actions';
import * as createInvestorDeckTypes from 'src/actions/investor-deck/create/Types';
import ResultPageCardComponent from 'src/modules/commons/result-page/ResultPageCard.Component';
import { GetUserAction, getUser } from 'src/actions/user/get/GetUser.actions';
import User from 'src/entities/User';
import Person from 'src/entities/Person';
import InvestorDeckData from 'src/value-objects/InvestorDeckData';
import { getInvestorDeck, GetInvestorDeckAction } from 'src/actions/investor-deck/get/GetInvestorDeck.actions';
import * as getInvestorDeckTypes from 'src/actions/investor-deck/get/Types';
import { history } from 'src/store';

interface StateProps {
  loggedUserData: number | null;
  user?: User;
  activeProfile?: Person;
  errorMessages: {};
}

interface DispatchProps {
  createInvestorDeck(investorDeck: InvestorDeckData): Promise<CreateInvestorDeckAction>;
  getUser(userId: number): Promise<GetUserAction>;
  getInvestorDeck(userId: number): Promise<GetInvestorDeckAction>;
}

interface Props extends DispatchProps, StateProps {
}

interface State {
  investorDeckSection: string;
  checks: { [key: string]: boolean };
  allowButton: boolean;
  investorDeckDocument?: File;
  investorDeckDocumentName?: string;
  deckDocument?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  disableButton: boolean;
  success: boolean;
}

class ShowInvestorDeckContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      investorDeckSection: 'companyInformation',
      checks: {
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
        check6: false,
      },
      allowButton: true,
      disableButton: true,
      success: false,
    };
  }

  public componentWillMount() {
    this.props.getInvestorDeck(this.props.loggedUserData!).then(
      (response) => {
        if (response.type === getInvestorDeckTypes.GET_INVESTOR_DECK_SUCCESS) {
          history.push('/');
        }
      }
    );
  }

  public componentDidMount() {
    if (!this.props.user) {
      this.props.getUser(this.props.loggedUserData!);
    }
  }

  public render(): React.ReactNode {
    return (
      !this.state.success ?
        (
          <InvestorDeckStepsComponent
            {...this.getComponentProps()}
          />
        ) :
        (
          <ResultPageCardComponent
            title={'Muchas gracias por enviarnos tu Investor Deck.'}
            // tslint:disable-next-line:max-line-length
            message={'Nuestro equipo de analistas revisará la información y se pondrá en contacto contigo en un plazo máximo de 2 semanas.'}
            success={true}
          />
        )
    );
  }

  private getComponentProps(): InvestorDeckComponentProps {
    return {
      disableButton: this.state.disableButton,
      investorDeckDocument: this.state.investorDeckDocument,
      investorDeckDocumentName: this.state.investorDeckDocumentName,
      allowButton: this.state.allowButton,
      checks: this.state.checks,
      errorMessages: this.props.errorMessages,
      createInvestorDeck: () => this.createInvestorDeck(),
      handleChange: (key: string) => this.handleChange(key),
      handleClick: (value: string) => this.handleClick(value),
      investorDeckSection: this.state.investorDeckSection,
    };
  }

  private handleChange(key: string): (value: boolean | File) => void {
    if (key === 'investorDeckDocument') {
      return (
        (value: File) => {
          this.setState({
            investorDeckDocument: value,
            investorDeckDocumentName: value.name,
            disableButton: false,
          });
          Base64Encoder.encode(value).then((result) => {
            let newDocument = {
              url: URL.createObjectURL(value),
              encoded: result.split('base64,')[1],
              ext: value.type.split('/')[1],
              name: value.name,
              size: value.size
            };
            this.setState({ deckDocument: newDocument });
          });
        });
    } else {
      return (
        (value: boolean) => {

          const actualChecksState = { ...this.state.checks, [key]: value };

          const allowButton = Object
            .keys(actualChecksState)
            .reduce(
              (acc: boolean, currentCheck: string) => {
                return acc && actualChecksState[currentCheck];
              },
              true
            );
          this.setState({
            checks: actualChecksState,
            allowButton: !allowButton
          });
        }
      );
    }
  }

  private createInvestorDeck(): void {
    if (this.state.deckDocument) {
      const investorDeck: InvestorDeckData = new InvestorDeckData({
        investorDeckDocument: this.state.deckDocument, 
        personId: this.props.activeProfile!.id,
        personType: this.props.activeProfile!.personType
      });
      this.props.createInvestorDeck(investorDeck).then((response: CreateInvestorDeckSuccess) => {
        if (response.type === createInvestorDeckTypes.CREATE_INVESTOR_DECK_SUCCESS) {
          this.setState({ success: true });
        }
      });
    }
  }

  private handleClick(value: string): void {
    this.setState({ investorDeckSection: value });
  }

}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  loggedUserData: state.authentication.loggedUserData,
  user: state.getUser.user,
  activeProfile: state.getUser.activeProfile,
  errorMessages: state.createInvestorDeck.errorMessage
});

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  createInvestorDeck: (investorDeck: InvestorDeckData): Promise<CreateInvestorDeckAction> => (
    dispatch(createInvestorDeck(investorDeck))
  ),
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
  getInvestorDeck: (userId: number): Promise<GetInvestorDeckAction> => (
    dispatch(getInvestorDeck(userId))
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowInvestorDeckContainer);



// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/InvestorDeckSteps.container.tsx